import iamClient from './iamClient.js';

// Identidade (login/senha) vive no iam — `/iam/api/*`. Cadastro é 2 passos:
// 1) registerIdentity cria a conta no iam (e-mail/nome/senha).
// 2) completeRegistration (patients.js) grava CPF/telefone/CEP/consentimentos
//    no iExame, usando o token que o passo 1 já devolveu.
export const login = async (email, password) => {
  const { data } = await iamClient.post('/api/login', { email, password });
  return data; // { access_token, refresh_token, token_type, expires_in }
};

export const registerIdentity = async ({ email, name, password }) => {
  const { data } = await iamClient.post('/api/register', { email, name, password });
  return data; // { access_token, refresh_token, token_type, expires_in }
};

export const refreshToken = async (token) => {
  const { data } = await iamClient.post('/api/refresh', { refresh_token: token });
  return data;
};

export const logout = async () => {
  await iamClient.post('/api/logout');
};

export const forgotPassword = async (email) => {
  const { data } = await iamClient.post('/api/forgot-password', { email });
  return data; // { sent: true }
};

export const resetPassword = async ({ token, password, confirmPassword }) => {
  const { data } = await iamClient.post('/api/reset-password', {
    token,
    password,
    confirm_password: confirmPassword,
  });
  return data;
};
